import utcToZonedTime from "date-fns-tz/utcToZonedTime";

/**
 * For backwards compatibility, parse dates with timezones as UTC.
 */
export const parseUtcDate = (date: string): Date =>
  utcToZonedTime(new Date(date), "UTC");
